import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";

import Fr_Input from "../../../lib/ui/fr_input";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import Fr_Cal from "../../../lib/ui/fr_cal";

class Ctx_Edit extends React.Component {
  constructor(props, context) {
    super(props);

    ///this.pos = props.store.pos;

    this.state = {};
    this.state.mka = [];

    this.state.gnr = "001";
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];
      this.state.ltval = [
          {id: 'bas', text: 'BAS LAYOUT'},
          {id: 'mnu', text: 'MENY LAYOUT'}
      ];

    this.state.msg = {};
    this.state.cols = {};
    this.state.lto = {};
    if(props.wnds.lto) this.state.lto = props.wnds.lto;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.btn_grps();
      //if(!this.props.wnds.tdo) this.task_init();
      //this.mnu_mp();
  }

    task_init() {
        var tdo = {};
        tdo.typ = "";
        tdo.id = "";
        tdo.text = "";
        tdo.reg = "";
        tdo.status = "";
        //alert(JSON.stringify(rso));
        this.setState({ tdo: tdo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        return css;
    }

    wnd_close = () => {
        if(this.props.close) {
            this.props.close(this.props.ctx);
        }
        else this.props.ctx.setState({ wnds: {} });
    };
    lt_change (e) {
        const value = e.target.value;
        var lto = this.state.lto;
        lto.lttyp = value;
        this.setState({lto: lto});
    }
    anm_change (e) {
        const value = e.target.value;
        var lto = this.state.lto;
        lto.anm = value;
        this.setState({lto: lto});
    }

    val_save(id, val) {
        var lto = this.state.lto;
        lto[id] = val;
        this.setState({ lto: lto });
        return;
    }
    mnu_mp() {
        var self = this;
        var prm = {};
        prm.req = "dsi.dsi_mp.mp_mnu";
        prm.mnuid = "mn02";

        net.sio_req(prm)
            .then(function(ret){
                alert(JSON.stringify(ret.rca));

                self.setState({ mna: ret.rca });
                //self.setState({ rva: ret.rca });
                self.syncTb("mnuTable");
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    ctx_upd() {
    var self = this;
    var prm = {};
    prm.req = "dsi.dsi_ctx.ctx_upd";
    prm.lto = this.state.lto;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({ msg: {ok: true, text: "Sparad ..."} });
            setTimeout(function(){
                self.setState({msg: {} });
                  if(self.props.wnds.cb) {
                      self.props.wnds.cb(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  ctx_del() {
    var self = this;
    var prm = {};
    prm.req = "dsi.dsi_ctx.ctx_del";
    prm.lto = this.state.lto;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({ msg: {ok: true, text: "Borttagen"} });
            setTimeout(function(){
                self.setState({msg: {} });
                  if(self.props.close) {
                      self.props.close(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "Resurs";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_90 flex-col" style={ this.dlg_style() } draggable="true" >
        <div className="mx_content flex">

        <div className="mx_h01">
            <div>Layout : { utils.toNum( this.state.lto.ctid ) }</div>
        </div>
            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
                <div className="flex-row">
                    <Fr_Input label="Layout ID" className="text-left w150" text={this.state.lto.ctid} getValue={(e)=> this.val_save("ctid", e) } />
                    <Fr_Input label="Status" className="text-left w350" text={this.state.lto.status} getValue={(e)=> this.val_save("status", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.lto.text} getValue={(e)=> this.val_save("text", e) } />
                </div>
                <div className="flex-row">
                    <div className="form-group flex-row flex">
                        <span className="header">Layout Typ</span>
                        <select value={this.state.lto.lttyp} className="form-control w250" onChange={(e) => this.lt_change(e)}>
                            { this.state.ltval.map((row, key) =>
                                <option key={key} value={row.id}>{row.text}</option>
                            )}
                        </select>
                    </div>
                </div>

                <div className="divider_green"></div>
                <div className="flex-row">
                    <Fr_Input label="Pos 1" className="text-left w150" text={this.state.lto.ct01pos} getValue={(e)=> this.val_save("ct01pos", e) } />
                    <Fr_Input label="ID 1" className="text-left w150" text={this.state.lto.ct01id} getValue={(e)=> this.val_save("ct01id", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Pos 2" className="text-left w150" text={this.state.lto.ct02pos} getValue={(e)=> this.val_save("ct02pos", e) } />
                    <Fr_Input label="ID 2" className="text-left w150" text={this.state.lto.ct02id} getValue={(e)=> this.val_save("ct02id", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Pos 3" className="text-left w150" text={this.state.lto.ct03pos} getValue={(e)=> this.val_save("ct03pos", e) } />
                    <Fr_Input label="ID 3" className="text-left w150" text={this.state.lto.ct03id} getValue={(e)=> this.val_save("ct03id", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Pos 4" className="text-left w150" text={this.state.lto.ct04pos} getValue={(e)=> this.val_save("ct04pos", e) } />
                    <Fr_Input label="ID 4" className="text-left w150" text={this.state.lto.ct04id} getValue={(e)=> this.val_save("ct04id", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Pos 5" className="text-left w150" text={this.state.lto.ct05pos} getValue={(e)=> this.val_save("ct05pos", e) } />
                    <Fr_Input label="ID 5" className="text-left w150" text={this.state.lto.ct05id} getValue={(e)=> this.val_save("ct05id", e) } />
                </div>
                <div className="divider_green"></div>
                <div className="flex-row">
                    <Fr_Input label="Kategori Storlek" className="text-left w150" text={this.state.lto.sz01} getValue={(e)=> this.val_save("sz01", e) } />
                    <Fr_Input label="Beskrivning Storlek" className="text-left w150" text={this.state.lto.sz02} getValue={(e)=> this.val_save("sz02", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Radtext Storlek" className="text-left w150" text={this.state.lto.sz03} getValue={(e)=> this.val_save("sz03", e) } />
                    <Fr_Input label="Radpris Storlek" className="text-left w150" text={this.state.lto.sz04} getValue={(e)=> this.val_save("sz04", e) } />
                    <Fr_Input label="Radbeskrivning Storlek" className="text-left w150" text={this.state.lto.sz05} getValue={(e)=> this.val_save("sz05", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Bakgrundsfärg" className="text-left w250" text={this.state.lto.bgcolor} getValue={(e)=> this.val_save("bgcolor", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Bakgrundsbild" className="text-left w350" text={this.state.lto.bgimg} getValue={(e)=> this.val_save("bgimg", e) } />
                </div>

                <div className="flex-row hide">
                    <div className="flex flex-column" style={{padding: "0px 5px"}}>
                        <span className="header">Layout information</span>
                        <textarea className="form-control" maxLength="512" rows="10" value={this.state.lto.anm} onChange={(e) => this.anm_change(e)}></textarea>
                    </div>
                </div>
            </form>

        </div>
        <div className="mx_foot flex-row">
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.ctx_del() } >
                TA BORT
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.ctx_upd() } >
                SPARA
            </button>
        </div>
      </div>

        <Wnd_Error msg={this.state.msg} ctx={this} />
        <Wnd_Ok msg={this.state.msg} ctx={this} />
        <Wnd_Info msg={this.state.msg} ctx={this} />
        <Wnd_Confirm msg={this.state.msg} ctx={this} />
      </div>
	;
	return html;
  };
}

export default Ctx_Edit;